import { getProfilesForLanguage, selectInitialLanguage, } from 'libs/locales/language-utils';
export const findLanguageWithProfiles = (initialLocale, profilesByPurpose, currentLanguage, availableLanguages) => {
    const profilesForCurrent = getProfilesForLanguage(profilesByPurpose, currentLanguage);
    if (profilesForCurrent.length > 0) {
        return { language: currentLanguage, profiles: profilesForCurrent };
    }
    const preferredLanguage = selectInitialLanguage(availableLanguages, initialLocale);
    const preferredProfiles = getProfilesForLanguage(profilesByPurpose, preferredLanguage);
    if (preferredProfiles.length > 0) {
        return { language: preferredLanguage, profiles: preferredProfiles };
    }
    if (availableLanguages.length > 0) {
        const firstAvailable = availableLanguages[0];
        const firstAvailableProfiles = getProfilesForLanguage(profilesByPurpose, firstAvailable);
        if (firstAvailableProfiles.length > 0) {
            return { language: firstAvailable, profiles: firstAvailableProfiles };
        }
    }
    return null;
};
